import React, { useEffect } from "react";
import PageHeader from "./PageHeader";

const slug = (s) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

/**
 * Shared shell for /privacy-policy and /terms-of-use. Both used to be
 * near-identical copies; keeping one layout means the numbering, measure and
 * contents rail stay in step.
 */
export default function LegalLayout({ title, updated, sections }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-agri-paper">
      <PageHeader kicker="Legal" title={title} meta={`Last updated ${updated}`} />

      <div className="container-x section-tight">
        <div className="grid grid-cols-1 gap-x-14 gap-y-10 lg:grid-cols-12">
          {/* Contents rail — a legal page is a reference document, so give
              the reader a way to jump rather than scroll-hunt */}
          <nav aria-label="Contents" className="lg:col-span-3">
            <p className="kicker mb-4">Contents</p>
            <ol className="lg:sticky lg:top-28">
              {sections.map((s, i) => (
                <li key={s.title}>
                  <a
                    href={`#${slug(s.title)}`}
                    className="flex gap-3 border-t border-agri-ruleSoft py-2.5 text-[0.8125rem] leading-snug text-agri-ink60 transition-colors hover:text-agri-clay"
                  >
                    <span className="font-mono text-[0.625rem] tabular-nums text-agri-ink40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {s.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          <div className="lg:col-span-8 lg:col-start-5">
            {sections.map((s, i) => (
              <section
                key={s.title}
                id={slug(s.title)}
                className="scroll-mt-28 border-t border-agri-rule py-8 first:border-t-0 first:pt-0"
              >
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-[0.6875rem] font-medium tabular-nums text-agri-clay">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="font-display text-[1.25rem] font-semibold leading-snug tracking-[-0.018em] text-agri-ink">
                    {s.title}
                  </h2>
                </div>
                <div className="article mt-4 pl-[1.75rem] text-[0.9375rem] leading-[1.75]">
                  {s.body}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
